// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__BWcay","headerWrapper":"style_headerWrapper__K0Tlu","title":"style_title__L1Jqd","img":"style_img__ZdDPo"};